import template from './zub.html';
import svg from 'svg.js';
import $ from 'jquery';

function zub($document, $timeout) {
    return {
        restrict: 'E',
        scope: {
            onClick: '&',
            ondblClick: '&',
            item: '='
        },
        link: function(scope, iElement, attrs) {
            const q = $;
            const SVG = svg('svg2');
            let bbox = null;
            // debugger;

            const group = SVG.group();
            group.attr('id', scope.item.id);
            scope.item.paths.map(p => {
                group.path(p).style({
                    stroke: '#000000',
                    cursor: 'pointer',
                    'stroke-width': 10.66666698,
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'miter',
                    'stroke-miterlimit': 4,
                    'stroke-dasharray': 'none',
                    'stroke-opacity': 1
                });
            });

            group.style({ fill: 'white' });

            if (scope.item) {
                if (scope.item.selected === true) {
                    const b = group.bbox();
                    bbox = SVG.rect(b.width, b.height)
                        .addClass('box')
                        .move(b.x, b.y)
                        .style({ fill: 'none', 'stroke-width': 10, stroke: 'black' });
                }

                if (scope.item.filled === true) {
                    group.style({ fill: '#dde3e1' });
                }
            }

            var dblclick_occured = false;
            var t = null;

            group.click(() => {
                $timeout(() => {
                    scope.onClick({ id: scope.item.id });
                });
            });

            scope.$on('$destroy', () => {
                group.off();
                if (bbox) {
                    bbox.remove();
                }
                group.remove();
            });

            // debugger;
        }
        // templateUrl: template
    };
}

zub.$inject = ['$document', '$timeout'];

export { zub };



// WEBPACK FOOTER //
// ./app/components/radniNalog/zub.directive.js